import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { catchError, Observable, of, take } from 'rxjs';
import { AuthResponse } from '../models/auth-model/auth.model';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public URL_API = environment.apiURLNew;
  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private generalService: GeneralService,
  ) {}

  public login(body: {
    browserName: string;
    isWeb: boolean;
    password: string;
    username: string;
  }): Observable<AuthResponse | null> {
    return this.http.post<AuthResponse>(this.URL_API + `/api/account/authenticate`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public refreshToken(body: {
    isWeb: boolean;
    refreshToken: string;
    token: string;
  }): Observable<AuthResponse | null> {
    return this.http.post<AuthResponse>(this.URL_API + `/api/account/refresh`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public logout() {
    localStorage.clear();
    this.dialog.closeAll();
    window.dispatchEvent(new CustomEvent('user-logout'));
    this.generalService.goToUrl(['/login'], {});
  }

  pingAlive(userId: number): Observable<boolean> {
    return this.http.get<boolean>(this.URL_API + '/api/ControlLoginUser/ping/' + userId);
  }

  public startPingLoop(): void {
    const ping = () => {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      if (token && userId) {
        this.pingAlive(Number(userId)).subscribe(() => {});
      }
      setTimeout(ping, 10 * 60 * 1000); // reintenta cada 10 minutos
    };

    // iniciar el loop
    ping();
  }
}
